module.exports = __webpack_public_path__ + "@/assets/img/sem-logo.21027234.png";